import { render, staticRenderFns } from "./UIGradientLoader.vue?vue&type=template&id=61967cea&scoped=true&"
import script from "./UIGradientLoader.vue?vue&type=script&lang=js&"
export * from "./UIGradientLoader.vue?vue&type=script&lang=js&"
import style0 from "./UIGradientLoader.vue?vue&type=style&index=0&id=61967cea&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-add9cc88d1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61967cea",
  null
  
)

export default component.exports